// Re-export everything from the split API service modules.
// All existing imports like `import { fetchRooms } from '@/lib/api'` continue to work.
export * from './api/index';
